import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as debug from 'debug';
import * as $ from 'jquery';
import * as _ from 'lodash';

@Pipe({
  name: 'svgSanitize',
})
export class SvgSanitize implements PipeTransform {
  log = debug('app:SvgSanitize');

  constructor(private domSanitizer: DomSanitizer) {}

  //remove final reference - The post <a rel="nofollow" href="https://cdllife.com/2018/video-tesla-driver-says-rear-ended-texting-trucker/">VIDEO: Tesla driver says he was rear-ended by texting trucker</a> appeared first on <a rel="nofollow" href="https://cdllife.com">CDLLife</a>.</p

  transform(html: string, ...args): SafeHtml {
    const domElement = $('<div></div>').html(html);
    console.log('hello', html)
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }

}



// WEBPACK FOOTER //
// ./src/pipes/svg-sanitize/svg-sanitize.ts